import {useEffect, useState} from "react"
import {Button, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useNavigate, useLocation, useParams} from "react-router-dom"
import {styled} from "@mui/material/styles"

import {partialPaymentAPI} from "@indebted/api"
import {ErrorPage} from "@indebted/components/Error"
import {LoadingPage} from "@indebted/components/Loading"
import {Page} from "@indebted/components/Page"
import {useAnalytics} from "@indebted/analytics"
import {AcceptedCards} from "@indebted/components/AcceptedCards"

function PaymentMethodSelection() {
	const {secureCode} = useParams()
	const {track} = useAnalytics()
	const [Component, setComponent] = useState(<LoadingPage />)
	const navigate = useNavigate()
	const location = useLocation()

	const PaymentMethods = ({paymentMethods, i18n}) => {
		return (
			<Page padded>
				<Grid
					container
					direction="column"
					alignItems="stretch"
					style={{width: "100%"}}
					justifyContent="center"
					spacing={5}
				>
					<Grid>
						<Typography variant="h6">{i18n.Header}</Typography>
					</Grid>
					<Grid>
						<Typography>{i18n.Title}</Typography>
					</Grid>

					<ButtonsGrid container direction="column" alignItems="stretch" spacing={5}>
						{paymentMethods.map((method) => (
							<Grid key={method.ID}>
								<Button
									fullWidth
									variant="outlined"
									onClick={() => {
										track("PartialPaymentMethodButtonClicked", {
											Method: method.ID,
											SecureCode: secureCode,
										})
										navigate(`/${secureCode}/partial-payment/${method.ID}${location.search}`)
									}}
								>
									{method.Display}
								</Button>
								<AcceptedCards list={method.AcceptedCards} />
							</Grid>
						))}
					</ButtonsGrid>
				</Grid>
			</Page>
		)
	}

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		partialPaymentAPI
			.getPaymentMethodPage({secureCode})
			.then((result) => {
				if (result.PaymentMethodOptions.length === 1) {
					navigate(`/${secureCode}/partial-payment/${result.PaymentMethodOptions[0].ID}${location.search}`, {
						replace: true,
					})
					return
				}
				track("PartialPaymentMethodPageViewed", {
					SecureCode: secureCode,
				})
				setComponent(<PaymentMethods paymentMethods={result.PaymentMethodOptions} i18n={result.I18n} />)
			})
			.catch((error) => {
				setComponent(<ErrorPage message={error.Message} error={error} />)
			})
	}, [secureCode])

	return Component
}

const ButtonsGrid = styled(Grid)`
	margin-top: 20px;
`

export {PaymentMethodSelection}
